import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "./ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import React from 'react';

const Brand = ({ onWhatsAppClick }) => {
	const images = [
    "/brands/solahart.png",
    "/brands/Ariston-Logo.jpg",
    "/brands/wika.webp",
    "/brands/initisolar.jpg",
    "/brands/dealdrop.webp",
    "/brands/handal.png",
    "/brands/polaris.jpeg"
  ]
  const plugin = React.useRef(
    Autoplay({
      delay: 2000,
      stopOnInteraction: false,  // tetap jalan meski di-interact
      stopOnMouseEnter: true,     // berhenti saat hover
    })
  )

  return (
	<section className="bg-white">
      <div className="container mx-auto px-4">

			<Carousel
				className="w-full"
				opts={{
					align: "start",
					loop: true,  // infinite loop
				}}

				plugins={[plugin.current]}

			>
			<CarouselContent>
				{images.map((img, index) => (
				<CarouselItem key={index} className="basis-1/3 lg:basis-1/6 flex">
					<div className="p-2 flex items-center">
						<img
							onClick={onWhatsAppClick}
							src={img}
							alt={`Brand ${index + 1}`}
							width={400}
							height={300}
							className="rounded-lg w-full object-cover items-center"
						/>
					</div>
				</CarouselItem>
				))}
			</CarouselContent>
			</Carousel>
	  </div>
	  </section>
  );
};

export default Brand;